import { createContext, useCallback, useContext, useState } from "react";
import { DICT } from "./dict";

const I18nContext = createContext(null);
const STORAGE_KEY = "masandi_lang";

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(STORAGE_KEY) || "id");

  const setLang = (l) => {
    localStorage.setItem(STORAGE_KEY, l);
    setLangState(l);
  };

  const t = useCallback((key, vars) => {
    let s = DICT[lang]?.[key] ?? DICT.id[key] ?? key;
    if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v));
    return s;
  }, [lang]);

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
